import React from "react";

interface Props {
  label: JSX.Element | string
  subLabel?: string
  link?: string
}

const SmallDetails = (props: Props) => {
  const { label, subLabel, link } = props;

  return <div>
    {link ? <a href={link}>{label}</a> : label}
    {subLabel && <div className="text-sublabel">
      {subLabel}
    </div>}
  </div>;
};

export default SmallDetails;